import React from "react"
import styled from "styled-components"
import { Link } from "gatsby"
import { motion } from "framer-motion"
import { colors } from "../../style/colors"

const Container = styled(motion.div)`
  background: #fff;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  height: 100vh;
  z-index: -1;
  padding: 30px;
  width: 70vw;
`
const MenuList = styled.nav`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  list-style: none;
  padding-top: 50px;
`
const Item = styled.li`
  margin: 0;
  margin-bottom: 13px;
  font-family: "Akkurat";
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
`
const ListItem = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
`
const Icon = styled.h5`
  margin: 0;
  font-size: 14px;
  color: black;
`
const Name = styled.h5`
  margin: 0;
  text-transform: uppercase;
  font-size: 14px;
  color: black;
`
const Submenu = styled.ul`
  list-style: none;
  margin: 0;
  display: ${props => (props.visible ? "block" : "none")};
`
const SubName = styled.h5`
  margin: 0;
  font-size: 13px;
  text-transform: none;
  margin-top: 6px;
  margin-left: 10px;
  color: #515151;
  transition: 0.2s ease;
  line-height: 17px;
  :hover {
    color: ${colors.main};
  }
`
const spring = {
  type: "spring",
  damping: 100,
  stiffness: 100,
}

const menu = {
  open: {
    opacity: 1,
    x: 0,
    transition: { staggerChildren: 0.07, delayChildren: 0.2, spring },
  },
  closed: {
    opacity: 0,
    x: "100%",
    transition: {
      staggerChildren: 0.05,
      staggerDirection: -1,
      spring,
      when: "afterChildren",
    },
  },
}

class Menu extends React.Component {
  state = {
    projects: [],
    activeCategory: "",
  }

  componentDidMount() {
    this.createMenu()
  }

  handleSelectCategory = category => {
    const { activeCategory } = this.state

    if (activeCategory === category) {
      //Collapse the menu by removing the active category
      this.setState({ activeCategory: null })
      return
    }

    this.setState({ activeCategory: category })
  }

  createMenu = () => {
    let projects = this.props.projects.map(project => {
      //Check to see if/whether a menu item is active
      //TODO: CHeck for unnecessary renders
      if (
        this.state.activeCategory === "" &&
        project.node.categories[0].slug === this.props.activeSlug
      ) {
        this.setState({ activeCategory: project.node.categories[0].name })
      }

      return {
        title: project.node.title,
        slug: project.node.slug,
        category: project.node.categories[0].name,
        categorySlug: project.node.categories[0].slug,
      }
    })

    this.setState({ projects })
  }

  renderSubMenu = category => {
    const { projects } = this.state
    let items = projects.filter(proj => proj.category === category)
    var menu = []
    items.map((item, index) =>
      menu.push(
        <ListItem key={index}>
          <SubName>
            <Link
              activeStyle={{ color: colors.main }}
              style={{ color: "inherit", textDecoration: "none" }}
              to={`/projects/${item.categorySlug}/${item.slug}`}
              state={{ category: item.category }}
            >
              {item.title}
            </Link>
          </SubName>
        </ListItem>
      )
    )

    return menu
  }


  render() {
    const { isOpen } = this.props
    const { activeCategory } = this.state
    return (
      <Container
        variants={menu}
        initial="closed"
        animate={isOpen ? "open" : "closed"}
        transition={spring}
      >
        <MenuList>
            {menuList.map((item, index) => {
              if (item.title === "Contact") {
                  return (
                      <ItemNav
                          key={index}
                          initial="hidden"
                          onClick={() => {
                              this.props.closeMenu()
                              this.props.setShowContact(true)
                          }}
                      >
                      {item.title}
                      </ItemNav>
                  )
              }
              return (
                  <MenuItem
                      key={index}
                      initial="hidden"
                      to={item.link}
                      activeStyle={{ color: colors.main, textDecoration: 'underline', textDecorationColor: colors.accent }}

                  >
                      {item.title}
                  </MenuItem>
              )
          })}
          <div style={{height: 40}} />
          {this.props.categories.filter(el => el.node.name !== "Uncategorized").map((category, index) => (
            <Item
              onClick={() => this.handleSelectCategory(category.node.name)}
              key={index}
            >
              <ListItem>
                <Icon>{activeCategory === category.node.name ? "−" : "+"}</Icon>
                <Name>{category.node.name}</Name>
              </ListItem>
              <Submenu visible={activeCategory === category.node.name}>
                {this.renderSubMenu(category.node.name)}
              </Submenu>
            </Item>
          ))}
        </MenuList>
      </Container>
    )
  }
}

export default Menu


const MenuItem = styled(Link)`
  text-transform: uppercase;
  font-family: "Akkurat";
  font-weight: 500;
  color: ${colors.copy};
  margin-bottom: 10px;
    text-decoration: none;
  font-size: 18px;
`
const ItemNav = styled.li`
  text-transform: uppercase;
  font-family: "Akkurat";
  font-weight: 500;
  color: ${colors.copy};
  margin-bottom: 10px;
    text-decoration: none;
  font-size: 18px;
`


const menuList = [
  {
    title: "About",
    link: '/about'
  },
  {
    title: "Team",
    link: "/team",
  },
  {
    title: "Services",
    link: "/services",
  },
  {
    title: "Projects",
    link: "/projects",
  },
  {
    title: "Contact",
    link: "http://beston.consulting/contact/",
  },
]